var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1802_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 17.5813C12.4766 14.7737 14.7737 12.4766 17.5813 12.4766H58.4192C59.773 12.4766 61.0715 13.0144 62.0288 13.9717C62.9861 14.929 63.5239 16.2274 63.5239 17.5813V22.686C63.5239 24.0399 62.9861 25.3383 62.0288 26.2956C61.0715 27.253 59.773 27.7908 58.4192 27.7908H17.5813C16.2274 27.7908 14.929 27.253 13.9717 26.2956C13.0144 25.3383 12.4766 24.0399 12.4766 22.686V17.5813ZM12.4766 35.4479C12.4766 32.6403 14.7737 30.3431 17.5813 30.3431H58.4192C59.773 30.3431 61.0715 30.881 62.0288 31.8383C62.9861 32.7956 63.5239 34.094 63.5239 35.4479V40.5526C63.5239 41.9065 62.9861 43.2049 62.0288 44.1622C61.0715 45.1195 59.773 45.6573 58.4192 45.6573H17.5813C16.2274 45.6573 14.929 45.1195 13.9717 44.1622C13.0144 43.2049 12.4766 41.9065 12.4766 40.5526V35.4479ZM12.4766 53.3145C12.4766 50.5068 14.7737 48.2097 17.5813 48.2097H58.4192C59.773 48.2097 61.0715 48.7475 62.0288 49.7049C62.9861 50.6622 63.5239 51.9606 63.5239 53.3145V58.4192C63.5239 59.773 62.9861 61.0715 62.0288 62.0288C61.0715 62.9861 59.773 63.5239 58.4192 63.5239H17.5813C16.2274 63.5239 14.929 62.9861 13.9717 62.0288C13.0144 61.0715 12.4766 59.773 12.4766 58.4192V53.3145ZM43.105 17.5813V22.686H48.2097V17.5813H43.105ZM53.3145 17.5813V22.686H58.4192V17.5813H53.3145ZM43.105 35.4479V40.5526H48.2097V35.4479H43.105ZM53.3145 35.4479V40.5526H58.4192V35.4479H53.3145ZM43.105 53.3145V58.4192H48.2097V53.3145H43.105ZM53.3145 53.3145V58.4192H58.4192V53.3145H53.3145Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1802_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.0474,
    height: 51.0474,
    fill: "white",
    transform: "translate(12.4766 12.4766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerIcon);
export default __webpack_public_path__ + "static/media/serverIcon.abf5eab252ebe86426dfee880996aad0.svg";
export { ForwardRef as ReactComponent };